import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
export function AnimatedCounter({ from, to, duration = 2000, decimals = 0, suffix = '', prefix = '', className = '' }) {
    const [count, setCount] = useState(from);
    useEffect(() => {
        let startTime;
        let animationFrame;
        const animate = (timestamp) => {
            if (!startTime)
                startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            // Use easeOutCubic easing function for smooth animation
            const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
            const easedProgress = easeOutCubic(progress);
            const current = from + (to - from) * easedProgress;
            setCount(current);
            if (progress < 1) {
                animationFrame = requestAnimationFrame(animate);
            }
        };
        animationFrame = requestAnimationFrame(animate);
        return () => {
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }
        };
    }, [from, to, duration]);
    const formatNumber = (num) => {
        if (decimals > 0) {
            return num.toFixed(decimals);
        }
        return Math.round(num).toString();
    };
    return (_jsxs("span", { className: `dashboard-counter-animate ${className}`, children: [prefix, formatNumber(count), suffix] }));
}
